import men from "../img/men.jpg";
import women from "../img/women.jpg";
import shoe from "../img/shoe.jpg";

export const imagesData = [
  {
    product: "MEN",
    title: men,
    link: men,
    route: "/men",
  },
  {
    product: "WOMEN",
    title: women,
    link: women,
    route: "/women",
  },
  {
    product: "SHOES",
    title: shoe,
    link: shoe,
    route: "/shoes",
  },
];
